"use strict";
var ConstraintRules = (function () {
    function ConstraintRules() {
    }
    return ConstraintRules;
}());
exports.ConstraintRules = ConstraintRules;
//# sourceMappingURL=D:/a/1/s/eligibility/src/rules/models/constraint-rules.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/eligibility/src/rules/models/constraint-rules.model.js